var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?_c('BaseLoading'):_vm._e(),(_vm.profileData !== null && !_vm.isLoading)?[_c('MainBlock',{attrs:{"profile-data":_vm.profileData}}),_c('ArtisansBlock',{attrs:{"artisans-data":_vm.artisansData}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }